import React from "react";
import { XIcon } from "lucide-react";
import { noMoreLines, problemLines } from "../data/content";
export function ProblemSection() {
  return <section className="bg-white px-4 py-16" aria-labelledby="problem-title" data-id="element-208" data-mp="2lu4ndghaxi66">
      <div className="mx-auto max-w-5xl" data-id="element-209" data-mp="30hzhn1ayjuld">
        <p className="text-center font-heading text-sm font-bold uppercase text-brand" data-id="element-210" data-mp="2vqhh2ecujw0x">Simple plans. Smart builds. Satisfying results.</p>
        <h2 id="problem-title" className="mx-auto mt-2 max-w-3xl text-center font-heading text-2xl font-bold uppercase leading-tight md:text-3xl" data-id="element-211" data-mp="39guo8ehwz6p7">
          Tired of confusing blueprints and incomplete plans?
        </h2>
        <div className="mt-12 grid gap-10 md:grid-cols-2" data-id="element-212" data-mp="3jfjvzeg3jarq">
          <div data-id="element-213" data-mp="3egh30sde4v04">
            <p className="text-lg font-medium" data-id="element-214" data-mp="3ei0hqejeexzs">You find a project you want to build.</p>
            <p className="mt-2 text-lg font-medium" data-id="element-215" data-mp="1p196r4vlaelf">Then the problems start.</p>
            <ul className="mt-6 space-y-4" data-id="element-216" data-mp="1k37naiu94d9f">
              {problemLines.map(l => <li key={l} className="flex items-start gap-3 text-ink-muted" data-id="element-217" data-mp="jd3nknzxobrf">
                  <XIcon className="mt-1 h-4 w-4 shrink-0 text-neutral-400" aria-hidden="true" data-id="element-218" data-mp="jb0ntc8zb49i" />
                  {l}
                </li>)}
            </ul>
          </div>
          <div className="rounded-xl bg-peach p-8" data-id="element-219" data-mp="sc8i7j8djkyb">
            <p className="font-heading text-xl font-bold uppercase" data-id="element-220" data-mp="x51q2fz539em">
              Woodworking Ready™ <span className="text-brand" data-id="element-221" data-mp="123v3k8eff0es">changes that.</span>
            </p>
            <p className="mt-4 text-sm leading-relaxed text-ink-muted" data-id="element-222" data-mp="125z5iksrlpcf">
              From clear technical views to exact measurements and ready-to-use cutting lists, you'll always know what comes next.
            </p>
            <ul className="mt-6 space-y-2 border-t border-brand/20 pt-6" data-id="element-223" data-mp="1g3498e50ac4i">
              {noMoreLines.map(l => <li key={l} className="font-heading text-sm font-semibold" data-id="element-224" data-mp="3dtxffv6r58cb">{l}</li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}